export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5562.d5b5f5fd.jpg";